// GETTERS
export const GET_PRESCRIPTION = 'prescription/GET_PRESCRIPTION';
export const GET_PRESCRIPTION_LIST = 'prescription/GET_PRESCRIPTION_LIST';


// MUTATORS
export const MUTATE_LIST_PRESCRIPTION = 'prescription/MUTATE_LIST_PRESCRIPTION';


// ACTIONS
export const ACTION_LIST_PRESCRIPTIONS = 'prescription/ACTION_LIST_PRESCRIPTIONS';
export const ACTION_ADD = 'prescription/ACTION_ADD';
export const ACTION_DELETE = 'prescription/ACTION_DELETE';
export const ACTION_UPDATE = 'prescription/ACTION_UPDATE';



// WEBPACK FOOTER //
// ./src/store/constants/prescription.js